import { LogLevel } from '../enums';

export class LogEntry {
  entryDate: Date = new Date();
  message: string;
  level: LogLevel = LogLevel.Debug;
  extraInfo: any[] = [];
  logWithDate = true;

  buildLogString(): string {
    let ret = '';

    if (this.logWithDate) {
      ret = `${new Date()} - `;
    }

    ret += `Type: ${LogLevel[this.level]} - `;
    ret += `Message: ${this.message} - `;
    if (this.extraInfo.length) {
      ret += `Extra Info: ${this.formatParams(this.extraInfo)}`;
    }

    return ret;
  }

  private formatParams(params: any[]): string {
    let ret: string = params.join(',');

    if (params.some(p => typeof p === 'object')) {
      ret = '';
      params.forEach(item => {
        ret += JSON.stringify(item) + ',';
      });
    }

    return ret;
  }
}
